import { Request } from '../../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../../httpClient/serverApi/types/IResponse';
import { ISiteScimConfiguration } from '../types/ISiteScimConfiguration';

export interface ICreateOrUpdateSiteScimConfigurationParams {
  siteScimConfiguration: ISiteScimConfiguration;
}

export class CreateOrUpdateSiteScimConfigurationRequest extends Request<ICreateOrUpdateSiteScimConfigurationParams, IResult> {
  constructor(params: ICreateOrUpdateSiteScimConfigurationParams) {
    super('createOrUpdateSiteScimConfiguration', params);
  }
}
